import {
  getLevelCatalogPath,
  getLevelGetAllPath,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { levelActions } from "../reducers/level";
import { toast } from "react-toastify";
import { fetchRewardList } from "./reward";
import { t } from "i18next";

export const fetchCatalogLevelList = (id) => {
  return (dispatch) => {
    return apiService
      .get(getLevelCatalogPath(id))
      .then((response) => {
        dispatch(levelActions.fetchCatalogLevelList(response.data));
        dispatch(fetchRewardList(response?.data[0]?.levelId));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchAllLevelList = () => {
  return (dispatch) => {
    return apiService
      .get(getLevelGetAllPath())
      .then((response) => {
        dispatch(levelActions.fetchAllLevelList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("security.error.refresh"), { theme: "colored" });
  }
  toast.error(errorMessage, { theme: "colored" });
};
